<template>
    <div class="commissionOpenClose">
        <el-dialog title="提示" :visible.sync="dialogVisible" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false" width="600">
            <div class="open" v-if="way === 1">
                <p class="title">开启后：</p>
                <div class="text">
                    <p>1、推广员购买商品，自己可以获得“直接推广佣金”，上级推广员可获得“间接推广佣金”；</p>
                    <p>2、推广员将无法成为其他人的客户，若以前是其他人的客户，客户关系会失效。</p>
                </div>
                <el-input v-model="value" placeholder="请输入确认开启"></el-input>
            </div>
            <div class="close" v-if="way === 0">
                <p class="title">关闭后：</p>
                <div class="text">
                    <p>1、推广员可以成为其他人的客户；</p>
                    <p>2、推广员购买商品，自己不会获得佣金，上级推广员将获得“直接推广佣金”。再上一级推广员获得“间接推广佣金”</p>
                </div>
                <el-input v-model="value" placeholder="请输入确认关闭"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'commissionOpenClose',
    data() {
        return {
            dialogVisible: false,
            value: ''
        }
    },
    props: ['way'],
    methods: {
        cancel() {
            if (this.way === 1) {
                this.$emit('setWay', 0)
            } else {
                this.$emit('setWay', 1)
            }
            this.dialogVisible = false
        },
        confirm() {
            if (this.way === 1) {
                if (this.value === '确认开启') {
                    this.dialogVisible = false
                    this.value = ''
                } else {
                    this.$message.error('请输入确认开启')
                }
            } else if (this.way === 0) {
                if (this.value === '确认关闭') {
                    this.value = ''
                    this.dialogVisible = false
                } else {
                    this.$message.error('请输入确认关闭')
                }
            }
        }
    }
}
</script>
<style lang="scss">
    .commissionOpenClose{
        .open, .close{
            .title{
                color: #F56C6C;
                line-height: 20px;
                margin-bottom: 10px;
            }
            .text{
                line-height: 20px;
            }
            .el-input{
                margin-top: 20px;
            }
        }
    }
</style>